import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { offlineForFetchFileInfo } from "./drive-data-offline-file-info";
import { getFileInfoFromLocal } from "./get-file-info-local";
import { getFileInfoOnline } from "./get-file-info-online";

// eslint-disable-next-line max-len

export var FileInfoFetchType = /*#__PURE__*/function (FileInfoFetchType) {
  FileInfoFetchType["Online"] = "Online";
  FileInfoFetchType["Offline"] = "Offline";
  FileInfoFetchType["Local"] = "Local";
  return FileInfoFetchType;
}({});
export var fetchFileInfo = function fetchFileInfo(req) {
  var _strategy;
  var fetchType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FileInfoFetchType.Offline;
  var strategy = (_strategy = {}, _defineProperty(_strategy, FileInfoFetchType.Online, getFileInfoOnline), _defineProperty(_strategy, FileInfoFetchType.Offline, offlineForFetchFileInfo(getFileInfoOnline)), _defineProperty(_strategy, FileInfoFetchType.Local, getFileInfoFromLocal), _strategy);
  var func = strategy[fetchType];
  if (!func) throw new Error("fetchFileInfo fail, reason: strategy not exist. strategy: ".concat(fetchType));
  return func(req);
};
//# sourceMappingURL=file-info.js.map